module.exports = __webpack_public_path__ + "media/images/news-4-763a99a9d844466fd4aa48cdd5a1fc67.jpg";